<template>
  <div id="wrapper" class="page master_schedule_custom_class">
    <meeting-side-bar index="4" />
    <div id="content-wrapper">
      <div id="master_schedule_fluid" class="container-fluid">
        <!-- #region TITLE MASTER SCHEDULE -->
        <div class="mydiv">
          <b-row class="">
            <b-col
              style="width:160px; min-width:160px;  max-width:160px; padding-right: 0px; padding-left: 0px;"
            >
              <!-- #region Back to last month -->
              <button
                class="btn-sm btn-outline-secondary border-0 float-left"
                style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                @click.prevent="$refs.vuecal.previous()"
              >
                <i
                  style="font-size: 31px !important;"
                  class="fas fa-angle-left"
                ></i>
              </button>
              <!--#endregion -->
              <!-- #region Filter Department -->
              <button
                class="btn-sm btn-outline-secondary border-0 float-left"
                style="background-color: #fde3c1; margin-left:3px;"
                id="popover-target-1"
              >
                <i
                  class="fas fa-filter"
                  style="font-size: 22px !important; padding: 2px 0px 2px 0px;"
                ></i>
              </button>
              <!--#endregion -->
            </b-col>
            <b-col
              style="flex-grow: 1; font-size: 20px; font-weight: bold;"
              class="text-center"
            >
              {{ $convert_date_string_master(this.startDate) }}
            </b-col>
            <b-col
              style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px;"
            >
              <div
                style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px; background-color: #2c2c2c; border-radius: 0.2rem;"
              >
                <!-- #region Add Master schedule -->
                <button
                  class="btn-sm border-0 button--pandora"
                  style="width: 80px; padding: 4px 2px 4px 4px; "
                  @click.prevent="openModal"
                  v-if="production_create"
                >
                  <i
                    class="fas fa-plus-circle"
                    style="float: left; font-size: 23px;"
                  ></i>
                  Add
                </button>
                <!--#endregion -->
              </div>
            </b-col>
            <b-col
              style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px;padding-left: 0px;"
            >
              <!-- #region Move to Today -->
              <button
                class="btn-sm btn-outline-secondary border-0 float-right"
                style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                @click.prevent="$refs.vuecal.next()"
              >
                <i
                  style="font-size: 31px !important;"
                  class="fas fa-angle-right"
                ></i>
              </button>
              <!--#endregion -->
              <!-- #region Move to Next month -->
              <button
                class="btn-sm btn-outline-secondary border-0 float-right"
                style="padding-top:4px; padding-bottom:3px; background-color: #fde3c1; margin-right:3px;"
                @click.prevent="$refs.vuecal.switchView('month', new Date())"
              >
                <i
                  style="font-size: 25px !important;"
                  class="fas fa-map-marker-alt "
                ></i>
              </button>
              <!--#endregion -->
            </b-col>
          </b-row>
        </div>
        <!--#endregion -->

        <!-- #region MASTER SCHEDULE -->
        <vue-cal
          ref="vuecal"
          hide-view-selector
          hide-title-bar
          today-button
          :disable-views="['years', 'year', 'week', 'day']"
          locale="en"
          :events="productions"
          :on-event-click="openUpdateModal"
          @hidden="closeModal"
          @ready="viewChange"
          @view-change="viewChange"
          :active-view.sync="activeView"
          events-on-month-view="short"
          id="master_schedule"
        >
          <template v-slot:weekday-heading="{ heading }">
            <div
              style="font-weight:bold; width: 100%; border-radius:3px; "
              :style="change_weekdays_headings_color(heading.label)"
            >
              {{ heading.label.substring(0, 3) }}
            </div>
          </template>
          <!-- #region Event in Date -->
          <template v-slot:cell-content="{ cell }">
            <span
              class="vuecal__cell-date m-1"
              :style="{
                color:
                  cell.class == 'vuecal__cell--day6' ||
                  cell.class == 'vuecal__cell--day7'
                    ? cell.outOfScope != true
                      ? '#ffb284'
                      : '#ffb38280'
                    : '',
              }"
              ><div>
                {{ cell.content }}
              </div>
            </span>
          </template>
          <template v-slot:no-event>{{&nbsp;}}</template>
          <template v-slot:event="{ event }">
            <!-- v-b-popover.hover.top="
                event.job.toUpperCase() + ' - ' + event.agency.toUpperCase()
              " -->
            <div
              :id="`popover-target-${event.productiondateid}`"
              style=" height: 50px; border-radius:3px; margin: 0px 5px 5px 5px;  font-weight: 400;"
              :style="change_background_color(event)"
            >
              <div class="text-center" style="padding: 1px 3px; display: flex;">
                <div
                  style="width: 40px; max-width: 40px; height: 50px; display: flex; align-items: center; justify-content: center;"
                >
                  <img
                    :src="change_department_logo(event.departmentid)"
                    style="margin-right: auto; margin-left: auto; display: block;"
                    :style="change_size_department_logo(event.departmentid)"
                  />
                </div>
                <div style="width:calc(100% - 40px);">
                  <div
                    id="job_event"
                    style="font-size: 13.6px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
                    v-html="
                      event.job.toUpperCase() +
                        ' - ' +
                        event.agency.toUpperCase()
                    "
                  ></div>
                  <div
                    style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
                    v-html="event.content"
                  ></div>
                </div>
              </div>
              <!-- #region HOVER EVENT -->
              <b-popover
                :target="`popover-target-${event.productiondateid}`"
                triggers="hover"
                placement="top"
                custom-class="my-popover-custom-class"
              >
                <!-- <template v-slot:title>
                  Choose filter
                </template> -->
                <div
                  style="font-size: 13px; white-space: nowrap;"
                  v-html="
                    event.job.toUpperCase() + ' - ' + event.agency.toUpperCase()
                  "
                ></div>
              </b-popover>
              <!--#endregion -->
            </div>
          </template>
          <!--#endregion -->
        </vue-cal>
        <!--#endregion -->

        <!-- #region FILTER DEPARTMENT -->
        <!-- triggers="focus hover" -->
        <b-popover
          target="popover-target-1"
          triggers="click blur"
          placement="top"
        >
          <template v-slot:title>
            Choose filter
          </template>
          <b-form autocomplete="off" @change.prevent="getProductions">
            <b-form-group>
              <template #label>
                <label style="font-weight:700;">Production House</label>
                <b-form-checkbox
                  v-model="allSelected"
                  :indeterminate="indeterminate"
                  @change="toggleAll"
                >
                  All
                </b-form-checkbox>
                <b-form-checkbox-group
                  v-model="production_departments_selected"
                  :options="production_departments"
                  value-field="id"
                  text-field="madonvi"
                  stacked
                ></b-form-checkbox-group>
                <div>---------------------</div>
                <b-form-checkbox-group
                  v-model="otherdate_selected"
                  :options="date_type_list"
                  value-field="type"
                  text-field="content"
                  stacked
                ></b-form-checkbox-group>
              </template>
            </b-form-group>
          </b-form>
        </b-popover>
        <!--#endregion -->
      </div>
    </div>

    <!-- #region PRODUCTION BOOKING MODAL -->
    <b-modal
      id="modal_add_master_booking"
      v-model="modalShow"
      size="lg"
      centered
      scrollable
      @hidden="closeModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      header-bg-variant="info"
      header-text-variant="light"
      hide-footer
    >
      <template v-slot:modal-title>
        <div v-if="is_creating_production">ADD MASTER SCHEDULE</div>
        <div v-else>EDIT MASTER SCHEDULE</div>
      </template>
      <b-form autocomplete="off" @submit.prevent="submitProduction">
        <b-row>
          <b-col>
            <button
              v-if="
                is_creating_production ||
                  (production_update && same_user) ||
                  production_admin
              "
              :disabled="disable_save_button"
              class="btn btn-info mr-2"
              style="float:right;"
              type="submit"
            >
              <i class="fas fa-save mr-2"></i> Save
            </button>
            <button
              v-if="
                !is_creating_production &&
                  production_delete &&
                  (same_user || production_admin)
              "
              style="float:right;"
              class="btn btn-danger mr-2"
              :disabled="disable_save_button"
              @click.prevent="deleteProduction"
            >
              <i class="fas fa-trash mr-2"></i> Delete
            </button>
          </b-col>
        </b-row>
        <!-- #region production -->
        <b-row>
          <b-col class="mb-2">
            <strong>
              I. INFORMATION:
            </strong>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Production House
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="production.departmentid"
                :options="production_departments_list"
                value-field="id"
                text-field="madonvi"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="is_booking_account || production_create">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Requester's Email
                <span class="text-danger">*</span>
              </template>
              <b-form-input
                type="email"
                v-model="production.email"
                :disabled="!is_creating_production || !is_booking_account"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Job (Brand - Project name)
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="production.job" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Agency
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="production.agency" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Client
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="production.client" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                EP
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="production.ep" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Producer
                <span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="production.producer"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                PM
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="production.ppm" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Director
                <span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="production.director"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                DOP
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="production.dop" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Posthouse
                <span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="production.posthouse"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="!is_creating_production">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Created at:
              </template>
              <b-form-input
                :value="createdat | moment('DD/MM/YYYY HH:mm')"
                readonly
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-2">
            <strong>
              II. SCHEDULE:
            </strong>
          </b-col>
        </b-row>
        <b-row>
          <!-- #endregion -->
        </b-row>
        <b-row>
          <!-- Job Confirmation Dates -->
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b-row>
                  <b-col
                    style="width: 165px; min-width: 165px; max-width: 165px; padding: 4px 0px 4px 15px;"
                  >
                    <div>
                      Job Confirmation <span class="text-danger">*</span>
                    </div>
                  </b-col>
                  <b-col style="padding-right:0">
                    <master-date-picker
                      :disabled="true"
                      :hidden="true"
                      v-model="job_confirmation_date_picker"
                    ></master-date-picker>
                  </b-col>
                  <b-col style="padding-left:0;max-width: 49.5px;">
                    <button
                      class="btn-sm btn-secondary_custom"
                      style="float:right; max-height:31px; min-width:34.5px;"
                      @click.prevent="openDateModal('Job Confirmation')"
                    >
                      <svg
                        viewBox="0 0 16 16"
                        width="17.5px"
                        height="17.5px"
                        focusable="false"
                        role="img"
                        aria-label="calendar"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi-calendar b-icon bi"
                      >
                        <g>
                          <path
                            fill-rule="evenodd"
                            d="M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1zm1-3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M3.5 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5zm9 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5z"
                          ></path>
                        </g>
                      </svg>
                    </button>
                  </b-col>
                </b-row>
              </template>
            </b-form-group>
          </b-col>
          <!-- Online prez Dates -->
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b-row>
                  <b-col
                    style="width: 165px; min-width: 165px; max-width: 165px; padding: 4px 0px 4px 15px;"
                  >
                    <div>Online Prez <span class="text-danger">*</span></div>
                  </b-col>
                  <b-col style="padding-right:0">
                    <master-date-picker
                      :disabled="true"
                      :hidden="true"
                      v-model="online_prez_date_picker"
                    ></master-date-picker>
                  </b-col>
                  <b-col style="padding-left:0;max-width: 49.5px;">
                    <button
                      class="btn-sm btn-secondary_custom"
                      style="float:right; max-height:31px; min-width:34.5px;"
                      @click.prevent="openDateModal('Online Prez')"
                    >
                      <svg
                        viewBox="0 0 16 16"
                        width="17.5px"
                        height="17.5px"
                        focusable="false"
                        role="img"
                        aria-label="calendar"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi-calendar b-icon bi"
                      >
                        <g>
                          <path
                            fill-rule="evenodd"
                            d="M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1zm1-3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M3.5 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5zm9 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5z"
                          ></path>
                        </g>
                      </svg>
                    </button>
                  </b-col>
                </b-row>
              </template>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <!-- PPM Dates -->
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b-row>
                  <b-col
                    style="width: 165px; min-width: 165px; max-width: 165px; padding: 4px 0px 4px 15px;"
                  >
                    <div>PPM <span class="text-danger">*</span></div>
                  </b-col>
                  <b-col style="padding-right:0">
                    <master-date-picker
                      :disabled="true"
                      :hidden="true"
                      v-model="ppm_date_picker"
                    ></master-date-picker>
                  </b-col>
                  <b-col style="padding-left:0;max-width: 49.5px;">
                    <button
                      class="btn-sm btn-secondary_custom"
                      style="float:right; max-height:31px; min-width:34.5px;"
                      @click.prevent="openDateModal('PPM')"
                    >
                      <svg
                        viewBox="0 0 16 16"
                        width="17.5px"
                        height="17.5px"
                        focusable="false"
                        role="img"
                        aria-label="calendar"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi-calendar b-icon bi"
                      >
                        <g>
                          <path
                            fill-rule="evenodd"
                            d="M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1zm1-3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M3.5 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5zm9 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5z"
                          ></path>
                        </g>
                      </svg>
                    </button>
                  </b-col>
                </b-row>
              </template>
            </b-form-group>
          </b-col>
          <!-- Master delivery Dates -->
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b-row>
                  <b-col
                    style="width: 165px; min-width: 165px; max-width: 165px; padding: 4px 0px 4px 15px;"
                  >
                    <div>
                      Master delivery <span class="text-danger">*</span>
                    </div>
                  </b-col>
                  <b-col style="padding-right:0">
                    <master-date-picker
                      :disabled="true"
                      :hidden="true"
                      v-model="master_delivery_date_picker"
                    ></master-date-picker>
                  </b-col>
                  <b-col style="padding-left:0;max-width: 49.5px;">
                    <button
                      class="btn-sm btn-secondary_custom"
                      style="float:right; max-height:31px; min-width:34.5px;"
                      @click.prevent="openDateModal('Master Delivery')"
                    >
                      <svg
                        viewBox="0 0 16 16"
                        width="17.5px"
                        height="17.5px"
                        focusable="false"
                        role="img"
                        aria-label="calendar"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi-calendar b-icon bi"
                      >
                        <g>
                          <path
                            fill-rule="evenodd"
                            d="M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1zm1-3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M3.5 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5zm9 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5z"
                          ></path>
                        </g>
                      </svg>
                    </button>
                  </b-col>
                </b-row>
              </template>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <!-- Fitting Dates -->
          <!-- <b-col>
            <b-form-group>
              <template v-slot:label>
                <b-row>
                  <b-col
                    style="width: 165px; min-width: 165px; max-width: 165px; padding: 4px 0px 4px 15px;"
                  >
                    <div>Fitting <span class="text-danger">*</span></div>
                  </b-col>
                  <b-col style="padding-right:0">
                    <master-date-picker
                      :disabled="true"
                      :hidden="true"
                      v-model="fitting_date_picker"
                    ></master-date-picker>
                  </b-col>
                  <b-col style="padding-left:0;max-width: 49.5px;">
                    <button
                      class="btn-sm btn-secondary_custom"
                      style="float:right; max-height:31px; min-width:34.5px;"
                      @click.prevent="openDateModal('Fitting')"
                    >
                      <svg
                        viewBox="0 0 16 16"
                        width="17.5px"
                        height="17.5px"
                        focusable="false"
                        role="img"
                        aria-label="calendar"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi-calendar b-icon bi"
                      >
                        <g>
                          <path
                            fill-rule="evenodd"
                            d="M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1zm1-3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M3.5 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5zm9 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5z"
                          ></path>
                        </g>
                      </svg>
                    </button>
                  </b-col>
                </b-row>
              </template>
            </b-form-group>
          </b-col> -->
          <!-- Shoot Dates -->
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b-row>
                  <b-col
                    style="width: 165px; min-width: 165px; max-width: 165px; padding: 4px 0px 4px 15px;"
                  >
                    <div>Shooting <span class="text-danger">*</span></div>
                  </b-col>
                  <b-col style="padding-right:0">
                    <master-date-picker
                      :disabled="true"
                      :hidden="true"
                      v-model="shooting_date_picker"
                    ></master-date-picker>
                  </b-col>
                  <b-col style="padding-left:0;max-width: 49.5px;">
                    <button
                      class="btn-sm btn-secondary_custom"
                      style="float:right; max-height:31px; min-width:34.5px;"
                      @click.prevent="openDateModal('Shooting')"
                    >
                      <svg
                        viewBox="0 0 16 16"
                        width="17.5px"
                        height="17.5px"
                        focusable="false"
                        role="img"
                        aria-label="calendar"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi-calendar b-icon bi"
                      >
                        <g>
                          <path
                            fill-rule="evenodd"
                            d="M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1zm1-3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M3.5 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5zm9 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5z"
                          ></path>
                        </g>
                      </svg>
                    </button>
                  </b-col>
                </b-row>
              </template>
            </b-form-group>
          </b-col>
          <!-- Other Dates -->
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b-row>
                  <b-col
                    style="width: 165px; min-width: 165px; max-width: 165px; padding: 4px 0px 4px 15px;"
                  >
                    <div>Other</div>
                  </b-col>
                  <b-col style="padding-right:0">
                    <master-date-picker
                      :disabled="true"
                      :hidden="true"
                      v-model="other_date_picker"
                    ></master-date-picker>
                  </b-col>
                  <b-col style="padding-left:0;max-width: 49.5px;">
                    <button
                      class="btn-sm btn-secondary_custom"
                      style="float:right; max-height:31px; min-width:34.5px;"
                      @click.prevent="openDateModal('Other')"
                    >
                      <svg
                        viewBox="0 0 16 16"
                        width="17.5px"
                        height="17.5px"
                        focusable="false"
                        role="img"
                        aria-label="calendar"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi-calendar b-icon bi"
                      >
                        <g>
                          <path
                            fill-rule="evenodd"
                            d="M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1zm1-3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M3.5 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5zm9 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5z"
                          ></path>
                        </g>
                      </svg>
                    </button>
                  </b-col>
                </b-row>
              </template>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <!-- Offline prez Dates -->
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b-row>
                  <b-col
                    style="width: 165px; min-width: 165px; max-width: 165px; padding: 4px 0px 4px 15px;"
                  >
                    <div>Offline Prez <span class="text-danger">*</span></div>
                  </b-col>
                  <b-col style="padding-right:0">
                    <master-date-picker
                      :disabled="true"
                      :hidden="true"
                      v-model="offline_prez_date_picker"
                    ></master-date-picker>
                  </b-col>
                  <b-col style="padding-left:0;max-width: 49.5px;">
                    <button
                      class="btn-sm btn-secondary_custom"
                      style="float:right; max-height:31px; min-width:34.5px;"
                      @click.prevent="openDateModal('Offline Prez')"
                    >
                      <svg
                        viewBox="0 0 16 16"
                        width="17.5px"
                        height="17.5px"
                        focusable="false"
                        role="img"
                        aria-label="calendar"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi-calendar b-icon bi"
                      >
                        <g>
                          <path
                            fill-rule="evenodd"
                            d="M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1zm1-3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M3.5 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5zm9 0a.5.5 0 0 1 .5.5V1a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5z"
                          ></path>
                        </g>
                      </svg>
                    </button>
                  </b-col>
                </b-row>
              </template>
            </b-form-group>
          </b-col>
          <b-col> </b-col>
        </b-row>
        <b-row>
          <b-col>
            <button
              v-if="
                is_creating_production ||
                  (production_update && (same_user || production_admin))
              "
              :disabled="disable_save_button"
              class="btn btn-info mr-2"
              style="float:right;"
              type="submit"
            >
              <i class="fas fa-save mr-2"></i> Save
            </button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <!--#endregion -->

    <!-- #region DATE MODAL -->
    <b-modal
      id="date_modal"
      v-model="dateModalShow"
      @hidden="closeDateModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      header-bg-variant="info"
      header-text-variant="light"
      hide-footer
    >
      <template v-slot:modal-title>DATE </template>
      <b-form autocomplete="off">
        <b-row style="margin-bottom: 10px;" v-if="!is_other_date()">
          <!-- class="sticky-top" -->
          <!-- <my-date-picker v-model="schedule_date"></my-date-picker> -->
          <b-col
            style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px; margin-right:8px; margin-left:auto;"
          >
            <!-- #region Add Date -->
            <button
              class="btn-sm border-0 btn-info"
              style="width: 80px; padding: 4px 2px 4px 4px;"
              @click.prevent="addItem()"
            >
              <i
                class="fas fa-plus-circle"
                style="float: left; font-size: 23px;"
              ></i>
              Add
            </button>
            <!--#endregion -->
          </b-col>
        </b-row>
        <b-row v-for="(item, index) in add_date_items" :key="index">
          <b-col class="pb-2" :class="!is_other_date() ? 'col-11' : 'col-4'">
            <master-date-picker
              v-model="item.date"
              :disabled="is_other_date()"
            ></master-date-picker>
          </b-col>
          <b-col v-if="is_other_date()" class="pb-2 col-8 pl-0">
            <input
              type="text"
              class="other_content_input"
              :value="item.content"
              :disabled="
                is_creating_production ||
                  !(production_update && (same_user || production_admin))
              "
              required
              @change="editContentDate(item, $event, index)"
            />
          </b-col>
          <b-col
            v-if="!is_other_date()"
            style="width: 30px; min-width: 30px; max-width: 30px; padding: 7px 4px;"
          >
            <!-- #region Delete Date -->
            <span>
              <b-link
                class="text-danger"
                href="#"
                @click.prevent="deleteAddDate(item)"
              >
                <i class="fas fa-trash" style="font-size: 20px;"></i>
              </b-link>
            </span>
            <!--#endregion -->
          </b-col>
        </b-row>
        <b-row style="margin-top: 10px;">
          <b-col
            style="width: 80px; min-width: 80px; max-width: 80px; padding-right: 0px;padding-left: 0px;  margin-right:8px; margin-left:auto;"
          >
            <!-- #region Save Date -->
            <button
              v-if="
                !is_creating_production ||
                  (is_creating_production && !is_other_date())
              "
              class="btn-sm border-0 btn-info"
              style="width: 80px; padding: 4px 2px 4px 4px; "
              @click.prevent="storeDate"
            >
              <i
                class="fas fa-save mr-2"
                style="float: left; font-size: 23px;"
              ></i>
              Save
            </button>
            <!--#endregion -->
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <!--#endregion -->
  </div>
</template>

<script>
import axios from "axios";
import MeetingSideBar from "../components/Meeting/MeetingSideBar";
import MasterDatePicker from "../components/App/MasterDatePicker";
// import VSwatches from "vue-swatches";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/vi.js";
import "vue-cal/dist/vuecal.css";

export default {
  name: "Productions",
  components: {
    MeetingSideBar,
    VueCal,
    // VSwatches,
    MasterDatePicker,
  },
  data() {
    return {
      production_schedule_date_type: null,
      production: {
        id: 0,
        productiondateid: 0,
        type: 0,
        departmentid: null,
        color: "",
        job: null,
        agency: null,
        // client: null,
        ep: null,
        producer: null,
        ppm: null,
        director: null,
        dop: null,
        posthouse: null,
        email: null,

        // status: 0,

        manhanvien: "",
        // address: "",
      },
      job_confirmation_date: {
        id: 0,
        productionscheduleid: 0,
        type: 1,
        content: "Job Confirmation",
        ngaybatdau: null,
        ngayketthuc: null,
      },
      ppm_date: {
        id: 0,
        productionscheduleid: 0,
        type: 2,
        content: "PPM",
        ngaybatdau: null,
        ngayketthuc: null,
      },
      // fitting_date: {
      //   id: 0,
      //   productionscheduleid: 0,
      //   type: 3,
      //   content: "Fitting",
      //   ngaybatdau: null,
      //   ngayketthuc: null,
      // },
      shooting_date: {
        id: 0,
        productionscheduleid: 0,
        type: 3,
        content: "Shooting",
        ngaybatdau: null,
        ngayketthuc: null,
      },
      offline_prez_date: {
        id: 0,
        productionscheduleid: 0,
        type: 4,
        content: "Offline Prez",
        ngaybatdau: null,
        ngayketthuc: null,
      },
      online_prez_date: {
        id: 0,
        productionscheduleid: 0,
        type: 5,
        content: "Online Prez",
        ngaybatdau: null,
        ngayketthuc: null,
      },
      master_delivery_date: {
        id: 0,
        productionscheduleid: 0,
        type: 6,
        content: "Master Delivery",
        ngaybatdau: null,
        ngayketthuc: null,
      },
      other_date: {
        id: 0,
        productionscheduleid: 0,
        type: 7,
        content: null,
        ngaybatdau: null,
        ngayketthuc: null,
      },
      job_confirmation_date_picker: null,
      ppm_date_picker: null,
      fitting_date_picker: null,
      shooting_date_picker: null,
      offline_prez_date_picker: null,
      online_prez_date_picker: null,
      master_delivery_date_picker: null,
      other_date_picker: null,
      production_flush: null,
      job_confirmation_date_flush: null,
      ppm_date_flush: null,
      // fitting_date_flush: null,
      shooting_date_flush: null,
      offline_prez_date_flush: null,
      online_prez_date_flush: null,
      master_delivery_date_flush: null,
      other_date_flush: null,
      disable_save_button: false,
      //   maxDate: null,
      //   minDate: null,
      /*job_confirmation_date*/
      items: [],
      job_confirmation_date_fields: [
        {
          key: "ngaybatdau",
          label: "Date",
          class: "text-center",
          thStyle: {
            height: "36px",
            width: "220px !important",
            minWidth: "120px !important",
          },
        },
        {
          key: "action",
          label: "",
          class: "text-center",
          thStyle: {
            height: "36px",
            minWidth: "35px !important",
          },
        },
      ],
      job_confirmation_date_items: [],
      /*pm_date*/
      ppm_date_fields: [
        {
          key: "ngaybatdau",
          label: "Date",
          class: "text-center",
          thStyle: {
            height: "36px",
            width: "220px !important",
            minWidth: "120px !important",
          },
        },
        {
          key: "action",
          label: "",
          class: "text-center",
          thStyle: {
            height: "36px",
            minWidth: "35px !important",
          },
        },
      ],
      ppm_date_items: [],
      /*fitting_date*/
      // fitting_date_fields: [
      //   {
      //     key: "ngaybatdau",
      //     label: "Date",
      //     class: "text-center",
      //     thStyle: {
      //       height: "36px",
      //       width: "220px !important",
      //       minWidth: "120px !important",
      //     },
      //   },
      //   {
      //     key: "action",
      //     label: "",
      //     class: "text-center",
      //     thStyle: {
      //       height: "36px",
      //       minWidth: "35px !important",
      //     },
      //   },
      // ],
      // fitting_date_items: [],
      /*shooting_date*/
      shooting_date_fields: [
        {
          key: "ngaybatdau",
          label: "Date",
          class: "text-center",
          thStyle: {
            height: "36px",
            width: "220px !important",
            minWidth: "120px !important",
          },
        },
        {
          key: "action",
          label: "",
          class: "text-center",
          thStyle: {
            height: "36px",
            minWidth: "35px !important",
          },
        },
      ],
      shooting_date_items: [],
      shooting_date_ngaybatdau_items: [],
      /*offline_prez_date*/
      offline_prez_date_fields: [
        {
          key: "ngaybatdau",
          label: "Date",
          class: "text-center",
          thStyle: {
            height: "36px",
            width: "220px !important",
            minWidth: "120px !important",
          },
        },
        {
          key: "action",
          label: "",
          class: "text-center",
          thStyle: {
            height: "36px",
            minWidth: "35px !important",
          },
        },
      ],
      offline_prez_date_items: [],
      /*online_prez_date*/
      online_prez_date_fields: [
        {
          key: "ngaybatdau",
          label: "Date",
          class: "text-center",
          thStyle: {
            height: "36px",
            width: "220px !important",
            minWidth: "120px !important",
          },
        },
        {
          key: "action",
          label: "",
          class: "text-center",
          thStyle: {
            height: "36px",
            minWidth: "35px !important",
          },
        },
      ],
      online_prez_date_items: [],
      /*master_delivery_date*/
      master_delivery_date_fields: [
        {
          key: "ngaybatdau",
          label: "Date",
          class: "text-center",
          thStyle: {
            height: "36px",
            width: "220px !important",
            minWidth: "120px !important",
          },
        },
        {
          key: "action",
          label: "",
          class: "text-center",
          thStyle: {
            height: "36px",
            minWidth: "35px !important",
          },
        },
      ],
      master_delivery_date_items: [],
      /*other_date*/
      other_date_fields: [
        {
          key: "ngaybatdau",
          label: "Date",
          class: "text-center",
          thStyle: {
            height: "36px",
            width: "220px !important",
            minWidth: "120px !important",
          },
        },
        {
          key: "content",
          label: "Content",
          class: "text-center",
          tdClass: "p-0",
          thStyle: {
            height: "36px",
            // width: "575px !important",
            minWidth: "210px !important",
          },
        },
        // {
        //   key: "action",
        //   label: "",
        //   thStyle: { width: "25px !important" },
        // },
      ],
      other_date_items: [],
      /*add_date*/
      add_date_fields: [
        {
          key: "adddate",
          label: "Date",
          class: "text-center",
          thStyle: {
            height: "36px",
            width: "420px !important",
            minWidth: "120px !important",
          },
        },
        {
          key: "action",
          label: "",
          class: "text-center",
          thStyle: {
            height: "36px",
            minWidth: "35px !important",
          },
        },
      ],
      add_date_items: [],
      schedule_date_items: [],
      productions: [],
      production_departments: [],
      production_departments_list: [],
      production_departments_selected: [],
      date_type_list: [],
      otherdate_selected: [],
      // employees: [],
      last_production_departments_selected: null,
      full_production_departments_selected: null,
      startDate: null,
      endDate: null,
      activeView: "month",
      modalShow: false,
      dateModalShow: false,
      approveModalShow: false,
      production_indexes: [],
      schedule_date: "",
      schedule_date_from: "",
      schedule_date_to: "",
      is_creating_production: true,
      is_creating_date: true,
      reject_comment: "",
      rejectModalShow: false,
      createdat: "",
    };
  },
  computed: {
    // production_read_all() {
    //   return this.$store.getters.hasPermission("production_read_all");
    // },
    // production_read() {
    //   return this.$store.getters.hasPermission("production_read");
    // },
    production_create() {
      return this.$store.getters.hasPermission("production_create");
    },
    production_update() {
      return this.$store.getters.hasPermission("production_update");
    },
    production_delete() {
      return this.$store.getters.hasPermission("production_delete");
    },
    production_admin() {
      return this.$store.getters.hasPermission("production_admin");
    },
    is_hide_pre_prod_post() {
      return this.$store.getters.hasPermission(
        "production_hide_pre_prod_post_view"
      );
    },
    same_user() {
      return this.$store.state.auth.name == this.production.manhanvien;
    },
    is_booking_account() {
      return this.$store.state.auth.name == this.$booking_account;
    },
    // is_admin_account() {
    //   return this.$store.state.auth.name == this.$admin_account;
    // },
  },
  beforeRouteEnter(to, from, next) {
    axios
      // .all([axios.get("/api/department"), axios.get("/api/employee/getall")])
      // .then(
      //   axios.spread((production_department, employee) => {
      //     next((vm) => vm.initData(production_department.data, employee.data));
      //   })
      // );
      .all([axios.get("/api/department")])
      .then(
        axios.spread((production_department) => {
          next((vm) => vm.initData(production_department.data));
        })
      );
  },
  // mounted() {
  //   addEventListener("mousemove", function(e) {
  //     let ele = document.getElementById("modal_add_master_booking___BV_modal_body_");
  //     let distance = ele.offsetLeft + ele.offsetWidth - e.pageX;
  //     distance < 30 && distance > -15
  //       ? ele.classList.add("more-width")
  //       : ele.classList.remove("more-width");
  //   });
  // },
  watch: {
    production_departments_selected(newValue, oldValue) {
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.production_departments.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
    schedule_date_items: function(newValue, oldValue) {
      if (newValue.length > 0) {
        let other_date_items_copy = this.other_date_items;
        this.other_date_items = [];
        var maxDate = Math.max.apply(null, newValue);
        var minDate = Math.min.apply(null, newValue);
        for (
          var dt = new Date(minDate);
          dt <= new Date(maxDate);
          dt.setDate(dt.getDate() + 1)
        ) {
          var temp = newValue.filter((x) => {
            var convert_date = new Date(x);
            return (
              convert_date.getDate() == dt.getDate() &&
              convert_date.getMonth() == dt.getMonth() &&
              convert_date.getFullYear() == dt.getFullYear()
            );
          });
          if (temp.length <= 0) {
            var check_already_other_date = other_date_items_copy.filter((x) => {
              var convert_date = new Date(x.ngaybatdau);
              return (
                convert_date.getDate() == dt.getDate() &&
                convert_date.getMonth() == dt.getMonth() &&
                convert_date.getFullYear() == dt.getFullYear() &&
                x.content != "Off" &&
                x.content != "Set-up" &&
                x.content != "Pre-Prod" &&
                x.content != "Post" &&
                x.content != "Other"
              );
            });
            if (check_already_other_date.length == 1) {
              let other_date = Object.assign({}, this.other_date);
              other_date.id = check_already_other_date[0].id;
              other_date.productionscheduleid =
                check_already_other_date[0].productionscheduleid;
              other_date.content = check_already_other_date[0].content;
              other_date.ngaybatdau = check_already_other_date[0].ngaybatdau;
              other_date.ngayketthuc = check_already_other_date[0].ngayketthuc;
              this.other_date_items.push(other_date);
            } else {
              var maxShootingDate = new Date(
                Math.max.apply(null, this.shooting_date_ngaybatdau_items)
              );
              var minShootingDate = new Date(
                Math.min.apply(null, this.shooting_date_ngaybatdau_items)
              );
              let other_date = Object.assign({}, this.other_date);
              other_date.ngaybatdau = new Date(dt);
              other_date.ngayketthuc = new Date(dt);
              if (dt > minShootingDate && dt < maxShootingDate) {
                // 86400000 thoi gian cach nhau 24 hour
                if (dt - minShootingDate == 86400000) {
                  other_date.content = "Off";
                } else {
                  other_date.content = "Set-up";
                }
              } else if (dt < minShootingDate) {
                other_date.content = "Pre-Prod";
              } else if (dt > maxShootingDate) {
                other_date.content = "Post";
              } else {
                other_date.content = "Other";
              }
              this.other_date_items.push(other_date);
            }
          }
        }
        if (this.other_date_items.length > 0) {
          this.other_date_picker = this.other_date_items[0].ngaybatdau.toString(
            "DD/MM/YYYY"
          );
        }
      }
    },
  },
  methods: {
    // initData(production_departments, employees) {
    initData(production_departments) {
      // this.employees = employees;
      production_departments.forEach((department) => {
        // if (department.madonvi != "ME" && department.madonvi != "YL") {
        this.production_departments_list.push(department);
        this.production_departments.push(department);
        // }
      });
      let other_date_filter = Object.assign({}, this.other_date);
      other_date_filter.content = "PRE-PROD/POST";
      this.date_type_list.push(other_date_filter);
      this.otherdate_selected = [];
      this.production_departments_selected = [];
      this.production_flush = this.$copy(this.production);
      this.job_confirmation_date_flush = this.$copy(this.job_confirmation_date);
      this.ppm_date_flush = this.$copy(this.ppm_date);
      // this.fitting_date_flush = this.$copy(this.fitting_date);
      this.shooting_date_flush = this.$copy(this.shooting_date);
      this.offline_prez_date_flush = this.$copy(this.offline_prez_date);
      this.online_prez_date_flush = this.$copy(this.online_prez_date);
      this.master_delivery_date_flush = this.$copy(this.master_delivery_date);
      this.other_date_flush = this.$copy(this.other_date);

      //   const select_all = { id: -1, madonvi: "All" };
      //   this.production_departments.unshift(select_all);

      const select_null = {
        id: null,
        madonvi: "Please select a Production House...",
      };
      this.production_departments_list.unshift(select_null);

      for (let i = 0; i < this.production_departments.length; i++) {
        this.production_departments_selected.push(
          this.production_departments[i].id
        );
      }
      if (!this.is_hide_pre_prod_post) {
        this.otherdate_selected.push(this.date_type_list[0].type);
      }
      this.last_production_departments_selected = this.production_departments_selected;
      this.full_production_departments_selected = this.production_departments_selected;

      this.getProductions();
    },
    is_other_date() {
      if (this.production_schedule_date_type != null) {
        return this.production_schedule_date_type.toUpperCase() == "OTHER"
          ? true
          : false;
      }
      return false;
    },
    viewChange(obj) {
      this.startDate = obj.startDate;
      this.endDate = obj.endDate;
      this.getProductions();
    },
    refreshAfterUpdate() {
      var position_save = window.scrollY;
      this.productions = [];
      let production_department_id = "";
      let date_type = "";

      //   let query = Object.assign({}, this.$route.query);
      if (this.production_departments_selected != null) {
        for (let i = 0; i < this.production_departments_selected.length; i++) {
          if (i != 0) production_department_id += ",";
          production_department_id += this.production_departments_selected[i];
        }
      }
      if (this.otherdate_selected != null) {
        for (let i = 0; i < this.otherdate_selected.length; i++) {
          if (i != 0) date_type += ",";
          date_type += this.otherdate_selected[i];
        }
      }
      axios
        .get("/api/production", {
          params: {
            production_department_id: production_department_id,
            date_type: date_type,
            start: this.startDate.getTime(),
            end: this.endDate.getTime(),
          },
        })
        .then((response) => {
          this.productions = response.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          this.disable_save_button = false;
        })
        .finally(() => {
          window.scrollTo({
            top: position_save,
          });
        });
    },
    toggleAll(checked) {
      if (checked) {
        this.production_departments.forEach((x) => {
          this.production_departments_selected.push(x.id);
        });
      } else {
        this.production_departments_selected = [];
      }
    },
    findDepartment(id) {
      const temp = this.production_departments.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.madonvi;
    },
    // #region Modal Master Schedule
    openModal() {
      this.is_creating_production = true;
      this.disable_save_button = false;
      if (!this.is_booking_account)
        this.production.email = this.$store.state.auth.email;
      this.production.color = "#fff";
      this.schedule_date_items = [];
      this.modalShow = true;
    },
    openUpdateModal(event, e) {
      this.production = JSON.parse(JSON.stringify(event));
      this.schedule_date_items = [];
      // let list_of_date = this.productions.filter((x) => x.id == event.id);
      // for (let itr of list_of_date) {
      //   this.production_indexes.push(
      //     this.productions.findIndex(
      //       (x) => x.productiondateid == itr.productiondateid
      //     )
      //   );
      // }
      this.createdat = this.production.createdat;
      this.job_confirmation_date_items = [];
      this.ppm_date_items = [];
      // this.fitting_date_items = [];
      this.shooting_date_items = [];
      this.shooting_date_ngaybatdau_items = [];
      this.offline_prez_date_items = [];
      this.online_prez_date_items = [];
      this.master_delivery_date_items = [];
      this.other_date_items = [];
      this.disable_save_button = false;

      axios
        .get(`/api/production/dates_of_production/${this.production.id}`)
        .then((res) => {
          res.data.forEach((event, index) => {
            var date = event;
            date.ngaybatdau = new Date(date.ngaybatdau);
            date.ngayketthuc = new Date(date.ngayketthuc);
            switch (event.type) {
              case 1:
                this.job_confirmation_date_items.push(date);
                this.schedule_date_items.push(date.ngaybatdau);
                break;
              case 2:
                this.ppm_date_items.push(date);
                this.schedule_date_items.push(date.ngaybatdau);

                break;
              // case 3:
              //   this.fitting_date_items.push(date);
              //   this.schedule_date_items.push(date.ngaybatdau);
              //   break;
              case 3:
                this.shooting_date_items.push(date);
                this.shooting_date_ngaybatdau_items.push(date.ngaybatdau);
                this.schedule_date_items.push(date.ngaybatdau);
                break;
              case 4:
                this.offline_prez_date_items.push(date);
                this.schedule_date_items.push(date.ngaybatdau);
                break;
              case 5:
                this.online_prez_date_items.push(date);
                this.schedule_date_items.push(date.ngaybatdau);
                break;
              case 6:
                this.master_delivery_date_items.push(date);
                this.schedule_date_items.push(date.ngaybatdau);
                break;
              case 7:
                this.other_date_items.push(date);
                break;
            }
          });

          this.job_confirmation_date_picker = this.$convert_date_string(
            this.job_confirmation_date_items[0].ngaybatdau
          );
          this.ppm_date_picker = this.$convert_date_string(
            this.ppm_date_items[0].ngaybatdau
          );
          // this.fitting_date_picker = this.$convert_date_string(
          //   this.fitting_date_items[0].ngaybatdau
          // );
          this.shooting_date_picker = this.$convert_date_string(
            this.shooting_date_items[0].ngaybatdau
          );
          this.offline_prez_date_picker = this.$convert_date_string(
            this.offline_prez_date_items[0].ngaybatdau
          );
          this.online_prez_date_picker = this.$convert_date_string(
            this.online_prez_date_items[0].ngaybatdau
          );
          this.master_delivery_date_picker = this.$convert_date_string(
            this.master_delivery_date_items[0].ngaybatdau
          );
          this.other_date_picker = this.$convert_date_string(
            this.other_date_items[0].ngaybatdau
          );
        });

      this.is_creating_production = false;
      this.modalShow = true;
    },
    closeModal() {
      this.production = this.$copy(this.production_flush);
      // this.production_indexes = [];
      this.job_confirmation_date_items = [];
      this.ppm_date_items = [];
      // this.fitting_date_items = [];
      this.shooting_date_items = [];
      this.shooting_date_ngaybatdau_items = [];
      this.offline_prez_date_items = [];
      this.online_prez_date_items = [];
      this.master_delivery_date_items = [];
      this.other_date_items = [];

      this.job_confirmation_date_picker = null;
      this.ppm_date_picker = null;
      this.fitting_date_picker = null;
      this.shooting_date_picker = null;
      this.offline_prez_date_picker = null;
      this.online_prez_date_picker = null;
      this.master_delivery_date_picker = null;
      this.other_date_picker = null;

      this.is_creating_production = false;
      this.disable_save_button = false;
      this.modalShow = false;
    },
    // deleteDate(data) {
    //   switch (data.item.content.toUpperCase()) {
    //     case "JOB CONFIRMATION":
    //       this.job_confirmation_date_items.splice(data.index, 1);
    //       break;
    //     case "PPM":
    //       this.ppm_date_items.splice(data.index, 1);
    //       break;
    //     case "FITTING":
    //       this.fitting_date_items.splice(data.index, 1);
    //       break;
    //     case "SHOOTING":
    //       this.shooting_date_items.splice(data.index, 1);
    //       this.shooting_date_ngaybatdau_items.splice(data.index, 1);
    //       break;
    //     case "OFFLINE PREZ":
    //       this.offline_prez_date_items.splice(data.index, 1);
    //       break;
    //     case "ONLINE PREZ":
    //       this.online_prez_date_items.splice(data.index, 1);
    //       break;
    //     case "MASTER DELIVERY":
    //       this.master_delivery_date_items.splice(data.index, 1);
    //       break;
    //   }
    //   this.schedule_date_items.splice(
    //     this.schedule_date_items.indexOf(data.item.ngaybatdau),
    //     1
    //   );
    // },
    editContentDate(data, event, index) {
      var new_item_content = event.target.value;

      if (!(new_item_content && new_item_content.length)) {
        this.$toast.error("Please enter your content!", "Error", {
          timeout: 3000,
        });
        event.target.value = data.content;
      } else {
        if (data.content.toLowerCase() != new_item_content.toLowerCase()) {
          this.other_date_items[index].content = new_item_content;

          this.$toast.success(
            "Your content has been changed, press the save button to save!",
            "SUCCESS",
            {
              timeout: 3000,
            }
          );
        }
      }
    },
    //#endregion

    //#region CRUD Production
    getProductions() {
      let production_department_id = "";
      let date_type = "";
      if (this.production_departments_selected != null) {
        for (let i = 0; i < this.production_departments_selected.length; i++) {
          if (i != 0) production_department_id += ",";
          production_department_id += this.production_departments_selected[i];
        }
      }
      if (this.otherdate_selected != null) {
        for (let i = 0; i < this.otherdate_selected.length; i++) {
          if (i != 0) date_type += ",";
          date_type += this.otherdate_selected[i];
        }
      }
      axios
        .get("/api/production", {
          params: {
            production_department_id: production_department_id,
            date_type: date_type,
            start: this.startDate.getTime(),
            end: this.endDate.getTime(),
          },
        })
        .then((response) => {
          this.productions = response.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    submitProduction() {
      this.disable_save_button = true;
      if (
        !this.production.departmentid ||
        !this.production.email ||
        !this.production.job ||
        !this.production.agency ||
        // !this.production.client ||
        !this.production.ep ||
        !this.production.producer ||
        !this.production.ppm ||
        !this.production.director ||
        !this.production.dop ||
        !this.production.posthouse ||
        !this.production.color
      ) {
        this.$toast.error("Please fill out all the information!", "Error", {
          timeout: 2000,
        });
        this.disable_save_button = false;
        return;
      }
      if (
        this.is_booking_account &&
        !this.$email_format_regex.test(this.production.email)
      ) {
        this.$toast.error("Incorrect email format!", "Error", {
          timeout: 2000,
        });
        this.disable_save_button = false;
        return;
      }

      //   if (!this.is_booking_account) {
      //     this.production.email = "";
      //   }
      // let date;
      // if (this.job_confirmation_date_picker != null) {
      //   if (
      //     this.checkAlreadyDate(
      //       this.job_confirmation_date_picker,
      //       "Job Confirmation"
      //     )
      //   ) {
      //     return;
      //   } else if (
      //     this.job_confirmation_date_items.filter(
      //       (x) =>
      //         x.ngaybatdau.getTime() ==
      //         this.$convert_string_date(
      //           this.job_confirmation_date_picker
      //         ).getTime()
      //     ).length <= 0
      //   ) {
      //     date = Object.assign({}, this.job_confirmation_date);
      //     date.ngaybatdau = date.ngayketthuc = this.$convert_string_date(
      //       this.job_confirmation_date_picker
      //     );
      //     date.productiondateid = this.production.id;
      //     date.content = "Job Confirmation";
      //     date.type = 1;

      //     this.job_confirmation_date_items.push(date);
      //     this.schedule_date_items.push(date.ngaybatdau);
      //   }
      // }

      if (this.job_confirmation_date_items.length == 0) {
        this.$toast.error("There is no Job Confirmation date yet!", "Error", {
          timeout: 2000,
        });
        this.disable_save_button = false;
        return;
      }

      if (this.ppm_date_items.length == 0) {
        this.$toast.error("There is no ppm date yet!", "Error", {
          timeout: 2000,
        });
        this.disable_save_button = false;
        return;
      }

      // if (this.fitting_date_items.length == 0) {
      //   this.$toast.error("There is no Fitting date yet!", "Error", {
      //     timeout: 2000,
      //   });
      //   this.disable_save_button = false;
      //   return;
      // }

      if (this.shooting_date_items.length == 0) {
        this.$toast.error("There is no Shooting date yet!", "Error", {
          timeout: 2000,
        });
        this.disable_save_button = false;
        return;
      }

      if (this.offline_prez_date_items.length == 0) {
        this.$toast.error("There is no Offline Prez date yet!", "Error", {
          timeout: 2000,
        });
        this.disable_save_button = false;
        return;
      }

      if (this.online_prez_date_items.length == 0) {
        this.$toast.error("There is no Online Prez date yet!", "Error", {
          timeout: 2000,
        });
        this.disable_save_button = false;
        return;
      }

      if (this.master_delivery_date_items.length == 0) {
        this.$toast.error("There is no Master Dalivery date yet!", "Error", {
          timeout: 2000,
        });
        this.disable_save_button = false;
        return;
      }
      const payload = {
        job_confirmation_dates: this.job_confirmation_date_items,
        ppm_dates: this.ppm_date_items,
        // fitting_dates: this.fitting_date_items,
        shooting_dates: this.shooting_date_items,
        offline_prez_dates: this.offline_prez_date_items,
        online_prez_dates: this.online_prez_date_items,
        master_delivery_dates: this.master_delivery_date_items,
        other_dates: this.other_date_items,

        production: this.production,
      };
      if (this.is_creating_production) this.storeProduction(payload);
      else this.updateProduction(payload);
    },
    storeProduction(payload) {
      axios
        .post("/api/production", payload)
        .then((res) => {
          for (let data of res.data) {
            this.productions.push(data);
          }
          this.$toast.success("Successfully create Production!", "Success", {
            timeout: 2000,
          });
          this.refreshAfterUpdate();
          this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          this.disable_save_button = false;
        });
    },
    updateProduction(payload) {
      axios
        .put("/api/production", payload)
        .then((res) => {
          for (let production of res.data) {
            let date_index = this.productions.findIndex(
              (x) => x.productiondateid == production.productiondateid
            );
            this.productions = this.$insert_array_parse_json(
              production,
              this.productions,
              date_index
            );
          }

          this.$toast.success("Successfully update Production!", "Success", {
            timeout: 2000,
          });
          this.refreshAfterUpdate();
          this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          this.disable_save_button = false;
        });
    },
    deleteProduction() {
      this.$toast.question("Do you really want to delete?", "WARNING", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Yes</b></button>",
            (instance, toast) => {
              axios
                .put(`api/production/${this.production.id}`)
                .then((res) => {
                  this.refreshAfterUpdate();
                  this.closeModal();
                  this.$toast.success(
                    "Your Device has been deleted!",
                    "SUCCESS",
                    {
                      timeout: 3000,
                    }
                  );
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "ERROR", {
                    timeout: 3000,
                  });
                  this.disable_save_button = false;
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>No</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    //#endregion

    //#region Modal Add Date
    openDateModal(type) {
      this.production_schedule_date_type = type;
      this.add_date_items = [];
      switch (type.toUpperCase()) {
        case "JOB CONFIRMATION":
          if (
            this.$date_format_regex.test(this.job_confirmation_date_picker) &&
            this.job_confirmation_date_items.filter(
              (x) =>
                x.ngaybatdau.getTime() ==
                this.$convert_string_date(
                  this.job_confirmation_date_picker
                ).getTime()
            ).length <= 0
          ) {
            this.add_date_items.push({
              date: this.job_confirmation_date_picker,
              content: "Job Confirmation",
            });
          }
          if (this.job_confirmation_date_items.length > 0) {
            for (let date of this.job_confirmation_date_items) {
              this.add_date_items.push({
                date: this.$moment(date.ngaybatdau)
                  .format("DD/MM/YYYY")
                  .toString(),
                content: date.content,
              });
            }
          }
          break;
        case "PPM":
          if (
            this.$date_format_regex.test(this.ppm_date_picker) &&
            this.ppm_date_items.filter(
              (x) =>
                x.ngaybatdau.getTime() ==
                this.$convert_string_date(this.ppm_date_picker).getTime()
            ).length <= 0
          ) {
            this.add_date_items.push({
              date: this.ppm_date_picker,
              content: "PPM",
            });
          }
          if (this.ppm_date_items.length > 0) {
            for (let date of this.ppm_date_items) {
              this.add_date_items.push({
                date: this.$moment(date.ngaybatdau)
                  .format("DD/MM/YYYY")
                  .toString(),
                content: date.content,
              });
            }
          }
          break;
        // case "FITTING":
        //   if (
        //     this.$date_format_regex.test(this.fitting_date_picker) &&
        //     this.fitting_date_items.filter(
        //       (x) =>
        //         x.ngaybatdau.getTime() ==
        //         this.$convert_string_date(this.fitting_date_picker).getTime()
        //     ).length <= 0
        //   ) {
        //     this.add_date_items.push({
        //       date: this.fitting_date_picker,
        //       content: "Fitting",
        //     });
        //   }
        //   if (this.fitting_date_items.length > 0) {
        //     for (let date of this.fitting_date_items) {
        //       this.add_date_items.push({
        //         date: this.$moment(date.ngaybatdau)
        //           .format("DD/MM/YYYY")
        //           .toString(),
        //         content: date.content,
        //       });
        //     }
        //   }
        //   break;
        case "SHOOTING":
          if (
            this.$date_format_regex.test(this.shooting_date_picker) &&
            this.shooting_date_items.filter(
              (x) =>
                x.ngaybatdau.getTime() ==
                this.$convert_string_date(this.shooting_date_picker).getTime()
            ).length <= 0
          ) {
            this.add_date_items.push({
              date: this.shooting_date_picker,
              content: "Shooting",
            });
          }
          if (this.shooting_date_items.length > 0) {
            for (let date of this.shooting_date_items) {
              this.add_date_items.push({
                date: this.$moment(date.ngaybatdau)
                  .format("DD/MM/YYYY")
                  .toString(),
                content: date.content,
              });
            }
          }
          break;
        case "OFFLINE PREZ":
          if (
            this.$date_format_regex.test(this.offline_prez_date_picker) &&
            this.offline_prez_date_items.filter(
              (x) =>
                x.ngaybatdau.getTime() ==
                this.$convert_string_date(
                  this.offline_prez_date_picker
                ).getTime()
            ).length <= 0
          ) {
            this.add_date_items.push({
              date: this.offline_prez_date_picker,
              content: "Offline Prez",
            });
          }
          if (this.offline_prez_date_items.length > 0) {
            for (let date of this.offline_prez_date_items) {
              this.add_date_items.push({
                date: this.$moment(date.ngaybatdau)
                  .format("DD/MM/YYYY")
                  .toString(),
                content: date.content,
              });
            }
          }
          break;
        case "ONLINE PREZ":
          if (
            this.$date_format_regex.test(this.online_prez_date_picker) &&
            this.online_prez_date_items.filter(
              (x) =>
                x.ngaybatdau.getTime() ==
                this.$convert_string_date(
                  this.online_prez_date_picker
                ).getTime()
            ).length <= 0
          ) {
            this.add_date_items.push({
              date: this.online_prez_date_picker,
              content: "Online Prez",
            });
          }
          if (this.online_prez_date_items.length > 0) {
            for (let date of this.online_prez_date_items) {
              this.add_date_items.push({
                date: this.$moment(date.ngaybatdau)
                  .format("DD/MM/YYYY")
                  .toString(),
                ccontent: date.content,
              });
            }
          }
          break;
        case "MASTER DELIVERY":
          if (
            this.$date_format_regex.test(this.master_delivery_date_picker) &&
            this.master_delivery_date_items.filter(
              (x) =>
                x.ngaybatdau.getTime() ==
                this.$convert_string_date(
                  this.master_delivery_date_picker
                ).getTime()
            ).length <= 0
          ) {
            this.add_date_items.push({
              date: this.master_delivery_date_picker,
              content: "Master Delivery",
            });
          }
          if (this.master_delivery_date_items.length > 0) {
            for (let date of this.master_delivery_date_items) {
              this.add_date_items.push({
                date: this.$moment(date.ngaybatdau)
                  .format("DD/MM/YYYY")
                  .toString(),
                content: date.content,
              });
            }
          }
          break;
        case "OTHER":
          // if (this.$date_format_regex.test(this.other_date_picker)) {
          //   this.add_date_items.push({
          //     date: this.other_date_picker,
          //     content: "Other",
          //   });
          // }
          if (this.other_date_items.length > 0) {
            for (let date of this.other_date_items) {
              this.add_date_items.push({
                date: this.$moment(date.ngaybatdau)
                  .format("DD/MM/YYYY")
                  .toString(),
                content: date.content,
              });
            }
          }
          break;
      }
      if (this.add_date_items != null) {
        this.add_date_items.sort((a, b) => {
          var convert_a = this.$convert_string_date(a.date);
          var convert_b = this.$convert_string_date(b.date);
          if (convert_a > convert_b) return 1;
          if (convert_a < convert_b) return -1;
          return 0;
        });
      }
      if (this.add_date_items.length <= 0) {
        if (type.toUpperCase() == "OTHER") {
          this.$toast.error("No dates!", "ERROR", {
            timeout: 3000,
          });
          this.is_creating_date = false;
          this.dateModalShow = false;
          return;
        }
        this.addItem();
      }
      this.is_creating_date = true;
      this.dateModalShow = true;
    },
    closeDateModal() {
      this.job_confirmation_date = this.$copy(this.job_confirmation_date_flush);
      this.ppm_date = this.$copy(this.ppm_date_flush);
      // this.fitting_date = this.$copy(this.fitting_date_flush);
      this.shooting_date = this.$copy(this.shooting_date_flush);
      this.offline_prez_date = this.$copy(this.offline_prez_date_flush);
      this.online_prez_date = this.$copy(this.online_prez_date_flush);
      this.master_delivery_date = this.$copy(this.master_delivery_date_flush);
      this.other_date = this.$copy(this.other_date_flush);

      this.is_creating_date = false;
      // this.schedule_date = "";
      this.add_date_items = [];

      this.dateModalShow = false;
    },
    storeDate() {
      if (this.add_date_items.length == 0) {
        this.$toast.error("No date added!", "Error", {
          timeout: 2000,
        });
        return;
      }
      //#region Check already in schedule dates
      if (
        this.production_schedule_date_type.toUpperCase() != "JOB CONFIRMATION"
      ) {
        for (let date of this.job_confirmation_date_items) {
          if (
            this.add_date_items.filter(
              (x) =>
                this.$convert_string_date(x.date).getTime() ==
                date.ngaybatdau.getTime()
            ).length > 0
          ) {
            this.$toast.error(
              "Date " +
                this.$convert_date_string(date.ngaybatdau) +
                " already exist in Job Confirmation dates. Please try again!",
              "Error",
              { timeout: 2000 }
            );
            return;
          }
        }
      }
      if (this.production_schedule_date_type.toUpperCase() != "PPM") {
        for (let date of this.ppm_date_items) {
          if (
            this.add_date_items.filter(
              (x) =>
                this.$convert_string_date(x.date).getTime() ==
                date.ngaybatdau.getTime()
            ).length > 0
          ) {
            this.$toast.error(
              "Date " +
                this.$convert_date_string(date.ngaybatdau) +
                " already exist in PPM dates. Please try again!",
              "Error",
              { timeout: 2000 }
            );
            return;
          }
        }
      }
      // if (this.production_schedule_date_type.toUpperCase() != "FITTING") {
      //   for (let date of this.fitting_date_items) {
      //     if (
      //       this.add_date_items.filter(
      //         (x) =>
      //           this.$convert_string_date(x.date).getTime() ==
      //           date.ngaybatdau.getTime()
      //       ).length > 0
      //     ) {
      //       this.$toast.error(
      //         "Date " +
      //           this.$convert_date_string(date.ngaybatdau) +
      //           " already exist in Fitting dates. Please try again!",
      //         "Error",
      //         { timeout: 2000 }
      //       );
      //       return;
      //     }
      //   }
      // }
      if (this.production_schedule_date_type.toUpperCase() != "SHOOTING") {
        for (let date of this.shooting_date_items) {
          if (
            this.add_date_items.filter(
              (x) =>
                this.$convert_string_date(x.date).getTime() ==
                date.ngaybatdau.getTime()
            ).length > 0
          ) {
            this.$toast.error(
              "Date " +
                this.$convert_date_string(date.ngaybatdau) +
                " already exist in Shooting dates. Please try again!",
              "Error",
              { timeout: 2000 }
            );
            return;
          }
        }
      }
      if (this.production_schedule_date_type.toUpperCase() != "OFFLINE PREZ") {
        for (let date of this.offline_prez_date_items) {
          if (
            this.add_date_items.filter(
              (x) =>
                this.$convert_string_date(x.date).getTime() ==
                date.ngaybatdau.getTime()
            ).length > 0
          ) {
            this.$toast.error(
              "Date " +
                this.$convert_date_string(date.ngaybatdau) +
                " already exist in Offline Prez dates. Please try again!",
              "Error",
              { timeout: 2000 }
            );
            return;
          }
        }
      }
      if (this.production_schedule_date_type.toUpperCase() != "ONLINE PREZ") {
        for (let date of this.online_prez_date_items) {
          if (
            this.add_date_items.filter(
              (x) =>
                this.$convert_string_date(x.date).getTime() ==
                date.ngaybatdau.getTime()
            ).length > 0
          ) {
            this.$toast.error(
              "Date " +
                this.$convert_date_string(date.ngaybatdau) +
                " already exist in Online Prez dates. Please try again!",
              "Error",
              { timeout: 2000 }
            );
            return;
          }
        }
      }
      if (
        this.production_schedule_date_type.toUpperCase() != "MASTER DELIVERY"
      ) {
        for (let date of this.master_delivery_date_items) {
          if (
            this.add_date_items.filter(
              (x) =>
                this.$convert_string_date(x.date).getTime() ==
                date.ngaybatdau.getTime()
            ).length > 0
          ) {
            this.$toast.error(
              "Date " +
                this.$convert_date_string(date.ngaybatdau) +
                " already exist in Master Delivery dates. Please try again!",
              "Error",
              { timeout: 2000 }
            );
            return;
          }
        }
      }
      //#endregion

      //#region Add dates in schedule dates by date_type
      let date;
      let delete_date_items = [];
      let convert_add_date;
      try {
        switch (this.production_schedule_date_type.toUpperCase()) {
          case "JOB CONFIRMATION":
            for (let date of this.job_confirmation_date_items) {
              if (
                this.add_date_items.filter(
                  (x) =>
                    this.$convert_string_date(x.date).getTime() ==
                    date.ngaybatdau.getTime()
                ).length <= 0
              ) {
                delete_date_items.push(date);
              }
            }
            for (let delete_date of delete_date_items) {
              this.job_confirmation_date_items.splice(
                this.job_confirmation_date_items.indexOf(delete_date),
                1
              );
              this.schedule_date_items.splice(
                this.schedule_date_items.indexOf(delete_date.ngaybatdau),
                1
              );
            }
            for (let add_date of this.add_date_items) {
              convert_add_date = this.$convert_string_date(add_date.date);
              if (
                this.job_confirmation_date_items.filter(
                  (x) => x.ngaybatdau.getTime() == convert_add_date.getTime()
                ).length <= 0
              ) {
                date = Object.assign({}, this.job_confirmation_date);
                date.ngaybatdau = date.ngayketthuc = convert_add_date;
                date.productiondateid = this.production.id;
                date.content = "Job Confirmation";
                date.type = 1;

                this.job_confirmation_date_items.push(date);
                this.schedule_date_items.push(date.ngaybatdau);
              }
            }
            this.job_confirmation_date_items.sort((a, b) => {
              if (a.ngaybatdau > b.ngaybatdau) return 1;
              if (a.ngaybatdau < b.ngaybatdau) return -1;
              return 0;
            });
            this.job_confirmation_date_picker = this.$convert_date_string(
              this.job_confirmation_date_items[0].ngaybatdau
            );
            break;
          case "PPM":
            for (let date of this.ppm_date_items) {
              if (
                this.add_date_items.filter(
                  (x) =>
                    this.$convert_string_date(x.date).getTime() ==
                    date.ngaybatdau.getTime()
                ).length <= 0
              ) {
                delete_date_items.push(date);
              }
            }
            for (let delete_date of delete_date_items) {
              this.ppm_date_items.splice(
                this.ppm_date_items.indexOf(delete_date),
                1
              );
              this.schedule_date_items.splice(
                this.schedule_date_items.indexOf(delete_date.ngaybatdau),
                1
              );
            }
            for (let add_date of this.add_date_items) {
              convert_add_date = this.$convert_string_date(add_date.date);
              if (
                this.ppm_date_items.filter(
                  (x) => x.ngaybatdau.getTime() == convert_add_date.getTime()
                ).length <= 0
              ) {
                date = Object.assign({}, this.ppm_date);
                date.ngaybatdau = date.ngayketthuc = convert_add_date;
                date.productiondateid = this.production.id;
                date.content = "PPM";
                date.type = 2;

                this.ppm_date_items.push(date);
                this.schedule_date_items.push(date.ngaybatdau);
              }
            }
            this.ppm_date_items.sort((a, b) => {
              if (a.ngaybatdau > b.ngaybatdau) return 1;
              if (a.ngaybatdau < b.ngaybatdau) return -1;
              return 0;
            });
            this.ppm_date_picker = this.$convert_date_string(
              this.ppm_date_items[0].ngaybatdau
            );
            break;
          // case "FITTING":
          // for (let date of this.fitting_date_items) {
          //   if (
          //     this.add_date_items.filter(
          //       (x) =>
          //         this.$convert_string_date(x.date).getTime() ==
          //         date.ngaybatdau.getTime()
          //     ).length <= 0
          //   ) {
          //     delete_date_items.push(date);
          //   }
          // }
          // for (let delete_date of delete_date_items) {
          //   this.fitting_date_items.splice(
          //     this.fitting_date_items.indexOf(delete_date),
          //     1
          //   );
          //   this.schedule_date_items.splice(
          //     this.schedule_date_items.indexOf(delete_date.ngaybatdau),
          //     1
          //   );
          // }
          // for (let add_date of this.add_date_items) {
          //   convert_add_date = this.$convert_string_date(add_date.date);
          //   if (
          //     this.fitting_date_items.filter(
          //       (x) => x.ngaybatdau.getTime() == convert_add_date.getTime()
          //     ).length <= 0
          //   ) {
          //     date = Object.assign({}, this.fitting_date);
          //     date.ngaybatdau = date.ngayketthuc = convert_add_date;
          //     date.productiondateid = this.production.id;
          //     date.content = "Fitting";
          //     date.type = 3;
          //     this.fitting_date_items.push(date);
          //     this.schedule_date_items.push(date.ngaybatdau);
          //   }
          // }
          // this.fitting_date_items.sort((a, b) => {
          //   if (a.ngaybatdau > b.ngaybatdau) return 1;
          //   if (a.ngaybatdau < b.ngaybatdau) return -1;
          //   return 0;
          // });
          // this.fitting_date_picker = this.$convert_date_string(
          //   this.fitting_date_items[0].ngaybatdau
          // );
          // break;
          case "SHOOTING":
            for (let date of this.shooting_date_items) {
              if (
                this.add_date_items.filter(
                  (x) =>
                    this.$convert_string_date(x.date).getTime() ==
                    date.ngaybatdau.getTime()
                ).length <= 0
              ) {
                delete_date_items.push(date);
              }
            }
            for (let delete_date of delete_date_items) {
              this.shooting_date_items.splice(
                this.shooting_date_items.indexOf(delete_date),
                1
              );
              this.shooting_date_ngaybatdau_items.splice(
                this.shooting_date_ngaybatdau_items.indexOf(
                  delete_date.ngaybatdau
                ),
                1
              );
              this.schedule_date_items.splice(
                this.schedule_date_items.indexOf(delete_date.ngaybatdau),
                1
              );
            }
            for (let add_date of this.add_date_items) {
              convert_add_date = this.$convert_string_date(add_date.date);
              if (
                this.shooting_date_items.filter(
                  (x) => x.ngaybatdau.getTime() == convert_add_date.getTime()
                ).length <= 0
              ) {
                date = Object.assign({}, this.shooting_date);
                date.ngaybatdau = date.ngayketthuc = convert_add_date;
                date.productiondateid = this.production.id;
                date.content = "Shooting";
                date.type = 3;
                this.shooting_date_items.push(date);
                this.shooting_date_ngaybatdau_items.push(date.ngaybatdau);
                this.schedule_date_items.push(date.ngaybatdau);
              }
            }
            this.shooting_date_items.sort((a, b) => {
              if (a.ngaybatdau > b.ngaybatdau) return 1;
              if (a.ngaybatdau < b.ngaybatdau) return -1;
              return 0;
            });
            this.shooting_date_picker = this.$convert_date_string(
              this.shooting_date_items[0].ngaybatdau
            );
            break;
          case "OFFLINE PREZ":
            for (let date of this.offline_prez_date_items) {
              if (
                this.add_date_items.filter(
                  (x) =>
                    this.$convert_string_date(x.date).getTime() ==
                    date.ngaybatdau.getTime()
                ).length <= 0
              ) {
                delete_date_items.push(date);
              }
            }
            for (let delete_date of delete_date_items) {
              this.offline_prez_date_items.splice(
                this.offline_prez_date_items.indexOf(delete_date),
                1
              );
              this.schedule_date_items.splice(
                this.schedule_date_items.indexOf(delete_date.ngaybatdau),
                1
              );
            }
            for (let add_date of this.add_date_items) {
              convert_add_date = this.$convert_string_date(add_date.date);
              if (
                this.offline_prez_date_items.filter(
                  (x) => x.ngaybatdau.getTime() == convert_add_date.getTime()
                ).length <= 0
              ) {
                date = Object.assign({}, this.offline_prez_date);
                date.ngaybatdau = date.ngayketthuc = convert_add_date;
                date.productiondateid = this.production.id;
                date.content = "Offline Prez";
                date.type = 4;
                this.offline_prez_date_items.push(date);
                this.schedule_date_items.push(date.ngaybatdau);
              }
            }
            this.offline_prez_date_items.sort((a, b) => {
              if (a.ngaybatdau > b.ngaybatdau) return 1;
              if (a.ngaybatdau < b.ngaybatdau) return -1;
              return 0;
            });
            this.offline_prez_date_picker = this.$convert_date_string(
              this.offline_prez_date_items[0].ngaybatdau
            );
            break;
          case "ONLINE PREZ":
            for (let date of this.online_prez_date_items) {
              if (
                this.add_date_items.filter(
                  (x) =>
                    this.$convert_string_date(x.date).getTime() ==
                    date.ngaybatdau.getTime()
                ).length <= 0
              ) {
                delete_date_items.push(date);
              }
            }
            for (let delete_date of delete_date_items) {
              this.online_prez_date_items.splice(
                this.online_prez_date_items.indexOf(delete_date),
                1
              );
              this.schedule_date_items.splice(
                this.schedule_date_items.indexOf(delete_date.ngaybatdau),
                1
              );
            }
            for (let add_date of this.add_date_items) {
              convert_add_date = this.$convert_string_date(add_date.date);
              if (
                this.online_prez_date_items.filter(
                  (x) => x.ngaybatdau.getTime() == convert_add_date.getTime()
                ).length <= 0
              ) {
                date = Object.assign({}, this.online_prez_date);
                date.ngaybatdau = date.ngayketthuc = convert_add_date;
                date.productiondateid = this.production.id;
                date.content = "Online Prez";
                date.type = 5;
                this.online_prez_date_items.push(date);
                this.schedule_date_items.push(date.ngaybatdau);
              }
            }
            this.online_prez_date_items.sort((a, b) => {
              if (a.ngaybatdau > b.ngaybatdau) return 1;
              if (a.ngaybatdau < b.ngaybatdau) return -1;
              return 0;
            });
            this.online_prez_date_picker = this.$convert_date_string(
              this.online_prez_date_items[0].ngaybatdau
            );
            break;
          case "MASTER DELIVERY":
            for (let date of this.master_delivery_date_items) {
              if (
                this.add_date_items.filter(
                  (x) =>
                    this.$convert_string_date(x.date).getTime() ==
                    date.ngaybatdau.getTime()
                ).length <= 0
              ) {
                delete_date_items.push(date);
              }
            }
            for (let delete_date of delete_date_items) {
              this.master_delivery_date_items.splice(
                this.master_delivery_date_items.indexOf(delete_date),
                1
              );
              this.schedule_date_items.splice(
                this.schedule_date_items.indexOf(delete_date.ngaybatdau),
                1
              );
            }
            for (let add_date of this.add_date_items) {
              convert_add_date = this.$convert_string_date(add_date.date);
              if (
                this.master_delivery_date_items.filter(
                  (x) => x.ngaybatdau.getTime() == convert_add_date.getTime()
                ).length <= 0
              ) {
                date = Object.assign({}, this.master_delivery_date);
                date.ngaybatdau = date.ngayketthuc = convert_add_date;
                date.productiondateid = this.production.id;
                date.content = "Master Delivery";
                date.type = 6;
                this.master_delivery_date_items.push(date);
                this.schedule_date_items.push(date.ngaybatdau);
              }
            }
            this.master_delivery_date_items.sort((a, b) => {
              if (a.ngaybatdau > b.ngaybatdau) return 1;
              if (a.ngaybatdau < b.ngaybatdau) return -1;
              return 0;
            });
            this.master_delivery_date_picker = this.$convert_date_string(
              this.master_delivery_date_items[0].ngaybatdau
            );
            break;
          default:
            date = null;
            break;
        }
        this.$toast.success("Your Dates has been added!", "SUCCESS", {
          timeout: 3000,
        });
      } catch (err) {
        this.$toast.error(err, "Error", {
          timeout: 2000,
        });
        return;
      }

      // #endregion
      this.closeDateModal();
    },
    deleteAddDate(data) {
      this.add_date_items.splice(this.add_date_items.indexOf(data), 1);
    },
    //#endregion
    checkAlreadyDate(date_picker, content) {
      var convert_date = this.$convert_string_date(date_picker);
      if (
        content.toUpperCase() != "JOB CONFIRMATION" &&
        this.job_confirmation_date_items.filter(
          (x) => x.ngaybatdau.getTime() == convert_date.getTime()
        ).length > 0
      ) {
        this.$toast.error(
          "Date " +
            date_picker +
            " already exist in Job Confirmation dates. Please try again!",
          "Error",
          { timeout: 2000 }
        );
        return true;
      }

      if (
        content.toUpperCase() != "PPM" &&
        this.ppm_date_items.filter(
          (x) => x.ngaybatdau.getTime() == convert_date.getTime()
        ).length > 0
      ) {
        this.$toast.error(
          "Date " +
            date_picker +
            " already exist in PPM dates. Please try again!",
          "Error",
          { timeout: 2000 }
        );
        return true;
      }
      // if (
      //   content.toUpperCase() != "FITTING" &&
      //   this.fitting_date_items.filter(
      //     (x) => x.ngaybatdau.getTime() == convert_date.getTime()
      //   ).length > 0
      // ) {
      //   this.$toast.error(
      //     "Date " +
      //       date_picker +
      //       " already exist in Fitting dates. Please try again!",
      //     "Error",
      //     { timeout: 2000 }
      //   );
      //   return true;
      // }
      if (
        content.toUpperCase() != "SHOOTING" &&
        this.shooting_date_items.filter(
          (x) => x.ngaybatdau.getTime() == convert_date.getTime()
        ).length > 0
      ) {
        this.$toast.error(
          "Date " +
            date_picker +
            " already exist in Shooting dates. Please try again!",
          "Error",
          { timeout: 2000 }
        );
        return true;
      }
      if (
        content.toUpperCase() != "OFFLINE PREZ" &&
        this.job_confirmation_date_items.filter(
          (x) => x.ngaybatdau.getTime() == convert_date.getTime()
        ).length > 0
      ) {
        this.$toast.error(
          "Date " +
            date_picker +
            " already exist in Offline Prez dates. Please try again!",
          "Error",
          { timeout: 2000 }
        );
        return true;
      }
      if (
        content.toUpperCase() != "ONLINE PREZ" &&
        this.job_confirmation_date_items.filter(
          (x) => x.ngaybatdau.getTime() == convert_date.getTime()
        ).length > 0
      ) {
        this.$toast.error(
          "Date " +
            date_picker +
            " already exist in Online Prez dates. Please try again!",
          "Error",
          { timeout: 2000 }
        );
        return true;
      }
      if (
        content.toUpperCase() != "MASTER DELIVERY" &&
        this.master_delivery_date_items.filter(
          (x) => x.ngaybatdau.getTime() == convert_date.getTime()
        ).length > 0
      ) {
        this.$toast.error(
          "Date " +
            date_picker +
            " already exist in Master Delivery dates. Please try again!",
          "Error",
          { timeout: 2000 }
        );
        return true;
      }
      return false;
    },
    addItem() {
      this.add_date_items.push({
        date: this.$moment(new Date())
          .format("DD/MM/YYYY")
          .toString(),
        content: "",
      });
    },
    //#region Change style event in Vue-cal
    change_background_color(event) {
      var departmentName = this.findDepartment(event.departmentid);
      if (event.content.toUpperCase() == "SHOOTING") {
        return {
          color: this.change_font_color("#f7f701"),
          "background-color": "#f7f701",
        };
        // } else if (event.content.toUpperCase() == "PPM") {
        //   return {
        //     color: this.change_font_color("#EA9999"),
        //     "background-color": "#EA9999",
        //   };
      } else if (event.content.toUpperCase() == "MASTER DELIVERY") {
        return {
          color: this.change_font_color("#df2d2d"),
          "background-color": "#df2d2d",
        };
      } else if (this.is_today(event.start)) {
        if (departmentName == "MAY") {
          //MAY
          return {
            color: this.change_font_color("#9086AB"),
            "background-color": "#9086AB",
          };
        } else if (departmentName == "18S") {
          //18S
          return {
            color: this.change_font_color("#92AC86"),
            "background-color": "#92AC86",
          };
        } else if (departmentName == "ECHO") {
          //ECHO
          return {
            color: this.change_font_color("#839BC3"),
            "background-color": "#839BC3",
          };
        } else if (departmentName == "GS") {
          //GS
          return {
            color: this.change_font_color("#929292"),
            "background-color": "#929292",
          };
        } else if (departmentName == "ME") {
          //ME
          return {
            color: this.change_font_color("#0678b4"),
            "background-color": "#0678b4",
          };
        } else if (departmentName == "YL") {
          //YL
          return {
            color: this.change_font_color("#62c3cc"),
            "background-color": "#62c3cc",
          };
        } else {
          //OTHER
          return {
            color: this.change_font_color("#8C8C8C"),
            "background-color": "#8C8C8C",
          };
        }
      } else if (departmentName == "MAY") {
        //MAY
        return {
          color: this.change_font_color("#b4a7d6"),
          "background-color": "#b4a7d6",
        };
      } else if (departmentName == "18S") {
        //18S
        return {
          color: this.change_font_color("#b6d7a8"),
          "background-color": "#b6d7a8",
        };
      } else if (departmentName == "ECHO") {
        //ECHO
        return {
          color: this.change_font_color("#a4c2f4"),
          "background-color": "#a4c2f4",
        };
      } else if (departmentName == "GS") {
        //GS
        return {
          color: this.change_font_color("#b7b7b7"),
          "background-color": "#b7b7b7",
        };
      } else if (departmentName == "ME") {
        //ME
        return {
          color: this.change_font_color("#0678b4"),
          "background-color": "#0678b4",
        };
      } else if (departmentName == "YL") {
        //YL
        return {
          color: this.change_font_color("#62c3cc"),
          "background-color": "#62c3cc",
        };
      } else {
        //OTHER
        return {
          color: this.change_font_color("#afafaf"),
          "background-color": "#afafaf",
        };
      }
    },
    change_department_logo(departmentid) {
      var departmentName = this.findDepartment(departmentid);
      var images = "";
      if (departmentName == "MAY") {
        //MAY
        images = require("../assets/Logo/May_logo.png");
      } else if (departmentName == "18S") {
        //18S
        images = require("../assets/Logo/18_logo.png");
      } else if (departmentName == "ECHO") {
        //ECHO
        images = require("../assets/Logo/Echo_logo.png");
      } else if (departmentName == "GS") {
        //GS
        images = require("../assets/Logo/Gingers_shots_logo.png");
      } else if (departmentName == "ME") {
        //ME
        images = require("../assets/Logo/MeGroup_logo.png");
      } else if (departmentName == "YL") {
        //YL
        images = require("../assets/Logo/Yamlive_logo.png");
      } else {
        //OTHER
      }
      return images;
    },
    change_size_department_logo(departmentid) {
      var departmentName = this.findDepartment(departmentid);
      if (departmentName == "MAY") {
        //MAY
        return { "max-height": "24px" };
      } else if (departmentName == "18S") {
        //18S
        return { "max-height": "35px" };
      } else if (departmentName == "ECHO") {
        //ECHO
        return { "max-height": "35px" };
      } else if (departmentName == "GS") {
        //ME
        return { "max-height": "19px" };
      } else if (departmentName == "ME") {
        //YL
        return { "max-height": "20px" };
      } else if (departmentName == "YL") {
        //GS
        return { "max-height": "25px" };
      } else {
        //OTHER
        return { "max-height": "25px" };
      }
    },
    change_weekdays_headings_color(day_name) {
      if (day_name == "Sunday" || day_name == "Saturday") {
        return { "background-color": "#ffb284" };
      } else {
        return { "background-color": "#ffd18b" };
      }
    },
    change_font_color(bg_color) {
      // refer ITU Rec. 709: (0.2126 - 0.7152 - 0.0722)
      bg_color = bg_color.replace("#", "");
      let r = parseInt(bg_color.substring(0, 2), 16);
      let g = parseInt(bg_color.substring(2, 4), 16);
      let b = parseInt(bg_color.substring(4, 6), 16);

      return (r * 0.2126 + g * 0.7152 + b * 0.0722) / 255 >= 0.5
        ? "hsl(0, 0%, 0%)"
        : "hsl(0, 0%, 100%)"; //black or white font color by lightness
    },
    is_today(date) {
      const today = new Date();
      if (
        today.getFullYear() == date.getFullYear() &&
        today.getMonth() == date.getMonth() &&
        today.getDate() == date.getDate()
      )
        return true;
      return false;
    },
    //#endregion
  },
};
</script>

<style>
#master_schedule_fluid .vuecal {
  height: calc(100vh - 120px);
}
#master_schedule_fluid.container-fluid {
  height: calc(100vh - 80px);
}
.my-popover-custom-class {
  max-width: none !important;
  border-radius: 8px !important;
}
.my-popover-custom-class .popover-body {
  background: #fff1de;
  font-style: italic;
  padding: 0.2rem 0.35rem;
  border-radius: 8px;
  /* width: fit-content; */
}
.my-popover-custom-class > .arrow::after {
  border-top-color: #fff1de !important;
}

.other_content_input {
  height: 31px;
  background-color: transparent;
  border: 1px solid #ced4da;
  border-radius: 0.2rem;
  display: block;
  width: 100%;
  padding: 8px 4px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
}
.other_content_input:focus-visible {
  border-bottom: 2px solid #5384d1;
  outline: none;
  /* box-shadow: 0 0 5px rgb(109, 109, 109); */
}
.pointer {
  cursor: pointer;
}
#date_modal.modal.show .modal-dialog {
  top: 222px;
}

.modal-dialog-scrollable .modal-body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(109, 118, 126, 0.8);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.modal-dialog-scrollable .modal-body::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
}
.modal-dialog-scrollable .modal-body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: hsl(0deg 0% 66%);
}
.modal-dialog-scrollable .modal-body::-webkit-scrollbar-thumb:hover {
  box-shadow: inset 0 0 6px rgba(52, 58, 64, 1);
}

.hidden_header {
  display: none;
}
.btn-secondary_custom {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  outline: none;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-left: none;
  fill: #363b3f;
}
.btn-secondary_custom:hover {
  outline: none;
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
}
.btn-secondary_custom:focus {
  outline: none;
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
}
#modal_add_master_booking .modal-content {
  min-width: 800px;
}
#modal_add_master_booking .modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 6rem);
}

/*
#modal_add_master_booking .modal-dialog {
  margin: 3rem auto;
} */
</style>
